import type { SourceSystem } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_SOURCE_SYSTEM: SourceSystem = {
  contactEmail: 'help@yusen.com',
  contactName: 'Yusen Support',
  contactPhone: '+1234567890',
  country: 'France',
  entity: 'Yusen Inc.',
  entityName: 'Yusen Headquarters',
  id: '1',
};

export const sourceSystemFactory: Factory<SourceSystem> = (overrides) => ({
  ...MOCK_SOURCE_SYSTEM,
  ...overrides,
});
